import { PROFILE_UPDATE_CARD_COMPLETED } from '../actions/actionTypes';

const defaultState = {
  cards: {},
};

function cardReducer(state = defaultState, action) {
  const { currentCard, completed } = action;

  // eslint-disable-next-line default-case
  switch (action.type) {
    case PROFILE_UPDATE_CARD_COMPLETED:
      return {
        ...state,
        cards: {
          ...state.cards,
          [currentCard]: {
            ...state.cards[currentCard],
            completed,
          },
        },
      };
  }

  return state;
}

export default cardReducer;
